import DetailPageWrapper from './Detail';
export default DetailPageWrapper;
